import React from 'react';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';
import CustomerPricingLookup from 'components/common/CustomerPricingLookup';
import { ICustomerPricingLookupProps } from 'components/common/CustomerPricingLookup/CustomerPricingLookup.properties';
interface IScopeOptions {
  isWarehouseScoped?: boolean;
  isProductScoped?: boolean;
}

export interface ICustomerPricingLookupFieldProps extends Omit<ICustomerPricingLookupProps, 'valueField' | 'displayField' | 'descriptionField' | 'column1Field' | 'column2Field'>, IScopeOptions {
  params?: any;
  fieldRef?: React.Ref<IBasicLookupFieldHandle>;
  onValueChange?(value: string): void;
  setFieldAsyncError?(fieldName: string, error: string): void;
}

const CustomerPricingLookupField = (props: Omit<ICustomerPricingLookupFieldProps, 'classes' | 'onFindOption' | 'onSearch'>, ref: React.Ref<IBasicLookupFieldHandle>) => {

  const {
    fieldRef,
    value,
    params = {},
    isWarehouseScoped = false,
    setFieldAsyncError,
    onSelectedItemChange,
    onChange,
    onValueChange,
    onInvalidChange,
    ...restProps
  } = props;

  return (
    <CustomerPricingLookup
      {...restProps}
      ref={fieldRef ? fieldRef : ref}
      params={params}
      ProductId={params?.ProductId ?? props?.ProductId}
      Warehouse={params?.Warehouse ?? props?.Warehouse}
      value={value as string}
      onBlur={props.onBlur}
      onSelectedItemChange={(item, inputText) => {
        if (onChange) {
          onChange(item?.ReturnValue ?? inputText);
        }
        if (onSelectedItemChange) {
          onSelectedItemChange(item ? { ...item, ReturnValue: item?.ReturnValue ?? inputText } : { ReturnValue: inputText, Discount: '0' }, inputText);
        }
      }}
      onInvalidChange={(invalid: boolean, invalidValue) => {
        if (onInvalidChange) {
          onInvalidChange(invalid, invalidValue);
        }
        if (setFieldAsyncError) {
          setFieldAsyncError(props.name, invalid ? 'Invalid Value' : null);
        }
      }}
      onChange={onValueChange} />
  );
};

export default React.memo(React.forwardRef(CustomerPricingLookupField));
